<div class="textarea-wrapper">
  <label *ngIf="label" class="text-black mb-0">{{ label }}</label>
  <textarea
    [rows]="rows"
    [placeholder]="placeholder"
    [disabled]="disabled"
    [(ngModel)]="value"
    [id]="id"
    [name]="name"
    (ngModelChange)="onInput($event)">
  </textarea>
</div>
